/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as VideoAuthRouteImport } from './routes/_videoAuth'
import { Route as EquipmentCheckRouteImport } from './routes/equipment-check'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as VideoDebugRouteImport } from './routes/video-debug'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password.index'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as AuthenticatedAppointmentsIndexRouteImport } from './routes/_authenticated/appointments/index'
import { Route as AuthenticatedAppointmentsAppointmentIdRouteImport } from './routes/_authenticated/appointments/$appointmentId'
import { Route as AuthenticatedAppointmentsNewRouteImport } from './routes/_authenticated/appointments/new'
import { Route as AuthenticatedAvailabilityIndexRouteImport } from './routes/_authenticated/availability/index'
import { Route as AuthenticatedCalendarIndexRouteImport } from './routes/_authenticated/calendar/index'
import { Route as AuthenticatedVersicherteIndexRouteImport } from './routes/_authenticated/versicherte/index'
import { Route as AuthenticatedVersicherteVersicherteIdRouteImport } from './routes/_authenticated/versicherte/$versicherteId'
import { Route as VideoAuthVideoAppointmentIdRouteImport } from './routes/_videoAuth/video.$appointmentId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoAuthRoute = VideoAuthRouteImport.update({
  id: '/_videoAuth',
  getParentRoute: () => rootRouteImport,
} as any)
const EquipmentCheckRoute = EquipmentCheckRouteImport.update({
  id: '/equipment-check',
  path: '/equipment-check',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoDebugRoute = VideoDebugRouteImport.update({
  id: '/video-debug',
  path: '/video-debug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResetPasswordRoute,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => ResetPasswordRoute,
} as any)
const AuthenticatedAppointmentsIndexRoute =
  AuthenticatedAppointmentsIndexRouteImport.update({
    id: '/appointments/',
    path: '/appointments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppointmentsAppointmentIdRoute =
  AuthenticatedAppointmentsAppointmentIdRouteImport.update({
    id: '/appointments/$appointmentId',
    path: '/appointments/$appointmentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppointmentsNewRoute =
  AuthenticatedAppointmentsNewRouteImport.update({
    id: '/appointments/new',
    path: '/appointments/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAvailabilityIndexRoute =
  AuthenticatedAvailabilityIndexRouteImport.update({
    id: '/availability/',
    path: '/availability/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarIndexRoute =
  AuthenticatedCalendarIndexRouteImport.update({
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVersicherteIndexRoute =
  AuthenticatedVersicherteIndexRouteImport.update({
    id: '/versicherte/',
    path: '/versicherte/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVersicherteVersicherteIdRoute =
  AuthenticatedVersicherteVersicherteIdRouteImport.update({
    id: '/versicherte/$versicherteId',
    path: '/versicherte/$versicherteId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const VideoAuthVideoAppointmentIdRoute =
  VideoAuthVideoAppointmentIdRouteImport.update({
    id: '/video/$appointmentId',
    path: '/video/$appointmentId',
    getParentRoute: () => VideoAuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/equipment-check': typeof EquipmentCheckRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRouteWithChildren
  '/video-debug': typeof VideoDebugRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/appointments/$appointmentId': typeof AuthenticatedAppointmentsAppointmentIdRoute
  '/appointments/new': typeof AuthenticatedAppointmentsNewRoute
  '/versicherte/$versicherteId': typeof AuthenticatedVersicherteVersicherteIdRoute
  '/video/$appointmentId': typeof VideoAuthVideoAppointmentIdRoute
  '/appointments/': typeof AuthenticatedAppointmentsIndexRoute
  '/availability/': typeof AuthenticatedAvailabilityIndexRoute
  '/calendar/': typeof AuthenticatedCalendarIndexRoute
  '/versicherte/': typeof AuthenticatedVersicherteIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/equipment-check': typeof EquipmentCheckRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/video-debug': typeof VideoDebugRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/appointments/$appointmentId': typeof AuthenticatedAppointmentsAppointmentIdRoute
  '/appointments/new': typeof AuthenticatedAppointmentsNewRoute
  '/versicherte/$versicherteId': typeof AuthenticatedVersicherteVersicherteIdRoute
  '/video/$appointmentId': typeof VideoAuthVideoAppointmentIdRoute
  '/appointments': typeof AuthenticatedAppointmentsIndexRoute
  '/availability': typeof AuthenticatedAvailabilityIndexRoute
  '/calendar': typeof AuthenticatedCalendarIndexRoute
  '/versicherte': typeof AuthenticatedVersicherteIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_videoAuth': typeof VideoAuthRouteWithChildren
  '/equipment-check': typeof EquipmentCheckRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRouteWithChildren
  '/video-debug': typeof VideoDebugRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/_authenticated/appointments/$appointmentId': typeof AuthenticatedAppointmentsAppointmentIdRoute
  '/_authenticated/appointments/new': typeof AuthenticatedAppointmentsNewRoute
  '/_authenticated/versicherte/$versicherteId': typeof AuthenticatedVersicherteVersicherteIdRoute
  '/_videoAuth/video/$appointmentId': typeof VideoAuthVideoAppointmentIdRoute
  '/_authenticated/appointments/': typeof AuthenticatedAppointmentsIndexRoute
  '/_authenticated/availability/': typeof AuthenticatedAvailabilityIndexRoute
  '/_authenticated/calendar/': typeof AuthenticatedCalendarIndexRoute
  '/_authenticated/versicherte/': typeof AuthenticatedVersicherteIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/equipment-check'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/video-debug'
    | '/dashboard'
    | '/settings'
    | '/reset-password/$token'
    | '/reset-password/'
    | '/appointments/$appointmentId'
    | '/appointments/new'
    | '/versicherte/$versicherteId'
    | '/video/$appointmentId'
    | '/appointments/'
    | '/availability/'
    | '/calendar/'
    | '/versicherte/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/equipment-check'
    | '/forgot-password'
    | '/login'
    | '/video-debug'
    | '/dashboard'
    | '/settings'
    | '/reset-password/$token'
    | '/reset-password'
    | '/appointments/$appointmentId'
    | '/appointments/new'
    | '/versicherte/$versicherteId'
    | '/video/$appointmentId'
    | '/appointments'
    | '/availability'
    | '/calendar'
    | '/versicherte'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_videoAuth'
    | '/equipment-check'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/video-debug'
    | '/_authenticated/dashboard'
    | '/_authenticated/settings'
    | '/reset-password/$token'
    | '/reset-password/'
    | '/_authenticated/appointments/$appointmentId'
    | '/_authenticated/appointments/new'
    | '/_authenticated/versicherte/$versicherteId'
    | '/_videoAuth/video/$appointmentId'
    | '/_authenticated/appointments/'
    | '/_authenticated/availability/'
    | '/_authenticated/calendar/'
    | '/_authenticated/versicherte/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  VideoAuthRoute: typeof VideoAuthRouteWithChildren
  EquipmentCheckRoute: typeof EquipmentCheckRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRouteWithChildren
  VideoDebugRoute: typeof VideoDebugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_videoAuth': {
      id: '/_videoAuth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof VideoAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/equipment-check': {
      id: '/equipment-check'
      path: '/equipment-check'
      fullPath: '/equipment-check'
      preLoaderRoute: typeof EquipmentCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video-debug': {
      id: '/video-debug'
      path: '/video-debug'
      fullPath: '/video-debug'
      preLoaderRoute: typeof VideoDebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof ResetPasswordRoute
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof ResetPasswordRoute
    }
    '/_authenticated/appointments/': {
      id: '/_authenticated/appointments/'
      path: '/appointments'
      fullPath: '/appointments/'
      preLoaderRoute: typeof AuthenticatedAppointmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/appointments/$appointmentId': {
      id: '/_authenticated/appointments/$appointmentId'
      path: '/appointments/$appointmentId'
      fullPath: '/appointments/$appointmentId'
      preLoaderRoute: typeof AuthenticatedAppointmentsAppointmentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/appointments/new': {
      id: '/_authenticated/appointments/new'
      path: '/appointments/new'
      fullPath: '/appointments/new'
      preLoaderRoute: typeof AuthenticatedAppointmentsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/availability/': {
      id: '/_authenticated/availability/'
      path: '/availability'
      fullPath: '/availability/'
      preLoaderRoute: typeof AuthenticatedAvailabilityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/': {
      id: '/_authenticated/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AuthenticatedCalendarIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/versicherte/': {
      id: '/_authenticated/versicherte/'
      path: '/versicherte'
      fullPath: '/versicherte/'
      preLoaderRoute: typeof AuthenticatedVersicherteIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/versicherte/$versicherteId': {
      id: '/_authenticated/versicherte/$versicherteId'
      path: '/versicherte/$versicherteId'
      fullPath: '/versicherte/$versicherteId'
      preLoaderRoute: typeof AuthenticatedVersicherteVersicherteIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_videoAuth/video/$appointmentId': {
      id: '/_videoAuth/video/$appointmentId'
      path: '/video/$appointmentId'
      fullPath: '/video/$appointmentId'
      preLoaderRoute: typeof VideoAuthVideoAppointmentIdRouteImport
      parentRoute: typeof VideoAuthRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedAppointmentsAppointmentIdRoute: typeof AuthenticatedAppointmentsAppointmentIdRoute
  AuthenticatedAppointmentsNewRoute: typeof AuthenticatedAppointmentsNewRoute
  AuthenticatedVersicherteVersicherteIdRoute: typeof AuthenticatedVersicherteVersicherteIdRoute
  AuthenticatedAppointmentsIndexRoute: typeof AuthenticatedAppointmentsIndexRoute
  AuthenticatedAvailabilityIndexRoute: typeof AuthenticatedAvailabilityIndexRoute
  AuthenticatedCalendarIndexRoute: typeof AuthenticatedCalendarIndexRoute
  AuthenticatedVersicherteIndexRoute: typeof AuthenticatedVersicherteIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedAppointmentsAppointmentIdRoute:
    AuthenticatedAppointmentsAppointmentIdRoute,
  AuthenticatedAppointmentsNewRoute: AuthenticatedAppointmentsNewRoute,
  AuthenticatedVersicherteVersicherteIdRoute:
    AuthenticatedVersicherteVersicherteIdRoute,
  AuthenticatedAppointmentsIndexRoute: AuthenticatedAppointmentsIndexRoute,
  AuthenticatedAvailabilityIndexRoute: AuthenticatedAvailabilityIndexRoute,
  AuthenticatedCalendarIndexRoute: AuthenticatedCalendarIndexRoute,
  AuthenticatedVersicherteIndexRoute: AuthenticatedVersicherteIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface VideoAuthRouteChildren {
  VideoAuthVideoAppointmentIdRoute: typeof VideoAuthVideoAppointmentIdRoute
}

const VideoAuthRouteChildren: VideoAuthRouteChildren = {
  VideoAuthVideoAppointmentIdRoute: VideoAuthVideoAppointmentIdRoute,
}

const VideoAuthRouteWithChildren = VideoAuthRoute._addFileChildren(
  VideoAuthRouteChildren,
)

interface ResetPasswordRouteChildren {
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
}

const ResetPasswordRouteChildren: ResetPasswordRouteChildren = {
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
}

const ResetPasswordRouteWithChildren = ResetPasswordRoute._addFileChildren(
  ResetPasswordRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  VideoAuthRoute: VideoAuthRouteWithChildren,
  EquipmentCheckRoute: EquipmentCheckRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRouteWithChildren,
  VideoDebugRoute: VideoDebugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
